import { ReviewersPage } from '@/components/pages/learn/ReviewersPage'

//GraphQL
import { GetStaticProps } from 'next'
import { getAllReviewers } from '@/graphql/Authors'
import { getReviewersPage } from '@/graphql/ReviewersPage'

export const getStaticProps: GetStaticProps = async ({ preview }) => {
  const page = await getReviewersPage(preview)
  const reviewers = await getAllReviewers(preview)
  return { props: { page, reviewers } }
}

export default ReviewersPage
